<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-toggle auto-hide="false">
            <img src="../assets/svg/logo-toolbar.svg">
          </ion-menu-toggle>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button class="btn-back" @click="$router.push('/yatch-details/'+$route.params.id)">Back</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <bg :opaque="0"></bg>
      <ion-grid>
        <ion-row class="row-boxed">
          <ion-col size-xs="12">
            <div class="text-right">
              <ion-button class="mt-20" @click="addReport" v-if="$store.state.user_role != 'client'">Add report</ion-button>
            </div>
          </ion-col>
          <ion-col size-xs="12">
            <ion-list>
              <ion-item v-for="(r) in reports" :key="'report-'+r.name">
                <ion-avatar slot="end">
                  <ion-button @click="$router.push('/report/details/' + r.id)">Create</ion-button>
                  <ion-button @click="$router.push('/report/edit/' + r.id)" v-if="$store.state.user_role != 'client'">Edit</ion-button>
                  <ion-button @click="editName(r.id, r.name)" v-if="$store.state.user_role != 'client'">Edit name</ion-button>
                  <ion-button @click="() => deleteReport(r.id, r.name)" v-if="$store.state.user_role != 'client'">Delete</ion-button>
                </ion-avatar>
                <ion-label>{{ r.name }}</ion-label>
              </ion-item>
              <ion-item v-if="!reports.length">
                <ion-label>No reports has been created</ion-label>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>

      </ion-grid>
      <loader :visible="loader"></loader>
    </ion-content>
  </ion-page>
</template>

<script>
import axios from "axios"
// import Vue from "vue"
export default {
  name: "ReportList",
  data: function() {
    return {
      loader: true,
      reports: []
    }
  },
  methods: {
    editName(id, name) {
      return this.$ionic.alertController
      .create({
        header: 'Edit report',
        inputs: [
          {
            name: 'report_name',
            id: 'report_name',
            placeholder: 'Name',
            value: name
          },
        ],
        buttons: [
          {
            text: 'Back',
            role: 'cancel',
            cssClass: 'secondary',
          },
          {
            text: 'Edit',
            handler: async(value) => {
              let name = value.report_name
              if(name) {
                this.loader = true;
                axios.post(this.apiUrl + '/api/v1/save-report', { api_token: this.$store.state.api_token, name: name, yacht_id: this.$route.params.id, id: id })
                .then(async(response) => {
                  let res = response.data
                  if(res.status == 1) {
                    this.getReports()
                    const toast = await this.$ionic.toastController.create({
                      message: 'Report edited succesfully',
                      color: 'success',
                      position: 'bottom',
                      duration: 2000
                    })
                    await toast.present();
                  }
                })
              } else {
                const toast = await this.$ionic.toastController.create({
                  message: 'Yacht name is required',
                  color: 'danger',
                  position: 'bottom',
                  duration: 3000
                })
                await toast.present();
                this.insert()
              }
            },
          },
        ],
      })
      .then(a => a.present())
    },
    addReport() {
      return this.$ionic.alertController
      .create({
        header: 'New report',
        inputs: [
          {
            name: 'report_name',
            id: 'report_name',
            placeholder: 'Name',
          },
        ],
        buttons: [
          {
            text: 'Back',
            role: 'cancel',
            cssClass: 'secondary',
          },
          {
            text: 'Insert',
            handler: async(value) => {
              let name = value.report_name
              if(name) {
                this.loader = true;
                axios.post(this.apiUrl + '/api/v1/save-report', { api_token: this.$store.state.api_token, name: name, yacht_id: this.$route.params.id })
                .then(async(response) => {
                  let res = response.data
                  if(res.status == 1) {
                    this.getReports()
                    const toast = await this.$ionic.toastController.create({
                      message: 'Report added succesfully',
                      color: 'success',
                      position: 'bottom',
                      duration: 2000
                    })
                    await toast.present();
                  }
                })
              } else {
                const toast = await this.$ionic.toastController.create({
                  message: 'Yacht name is required',
                  color: 'danger',
                  position: 'bottom',
                  duration: 3000
                })
                await toast.present();
                this.insert()
              }
            },
          },
        ],
      })
      .then(a => a.present())
    },
    deleteReport(id, name){
      return this.$ionic.alertController
      .create({
        header: 'Are you sure to delete "' + name + '" report?',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
            },
          },
          {
            text: 'Delete',
            handler: async() => {
              this.loader = true
              axios.post(this.apiUrl + '/api/v1/delete-report', { api_token: this.$store.state.api_token, id: id })
              .then(() => {
                this.getReports()
              })
            },
          },
        ]
      })
      .then(a => a.present())
    },
    getReports() {
      axios.post(this.apiUrl + '/api/v1/get-reports', { api_token: this.$store.state.api_token, id: this.$route.params.id })
      .then((response) => {
        let res = response.data
        if(res.data) {
          this.reports = res.data
        }
        this.loader = false;
      })

    }
  },
  mounted: async function() {
    this.getReports()
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ion-avatar {
  min-width: 320px;
  text-align: right;
}
</style>